import { Calendar } from '@teuteuf-games/calendar';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { styled } from 'styled-components';

import { BackButton } from '../components/buttons/BackButton';
import { PassportOffer } from '../components/PassportOffer';
import { useUser } from '../providers/UserProvider';
import { FIRST_ARCHIVE_DATE } from '../utils/archive';
import { getPuzzleNumber } from '../utils/helpers';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  gap: 12px;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 20px;
`;

type DateNumberPair = {
  date: string;
  number: number;
};

export const ArchiveRoute = () => {
  const { userDetails } = useUser();
  const history = useHistory();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const goToArchiveGame = (date: string) => {
    if (date === dayjs().format('YYYY-MM-DD')) {
      history.push('/');
      return;
    }
    history.push(`/archive/${date}`);
  };

  function generateDates(start: string): DateNumberPair[] {
    const startDate = dayjs(start);
    const today = dayjs();

    const dates: DateNumberPair[] = [];
    for (let d = startDate; d.isBefore(today); d = d.add(1, 'day')) {
      const dateString = d.format('YYYY-MM-DD');
      dates.push({ date: dateString, number: getPuzzleNumber(dateString) });
    }

    return dates;
  }

  const games = generateDates(FIRST_ARCHIVE_DATE);

  const playRandomGame = () => {
    const randomIndex = Math.floor(Math.random() * (games.length - 1)); // dont include todays game
    const randomGame = games[randomIndex];
    goToArchiveGame(randomGame.date);
  };

  return (
    <Container>
      <BackButton />

      <div className="space-y-3 text-justify pb-3 mb-3 w-full">
        <h3 className="text-xl font-bold mb-3">{t('archive.archive')}</h3>
        {!userDetails?.premiumGames?.includes('flagle') && (
          <>
            <p className="mb-3">{t('archive.accessArchive')}</p>
            <PassportOffer />
          </>
        )}
        {userDetails?.premiumGames?.includes('flagle') && (
          <>
            <p>
              {t('archive.gamesSince', {
                date: dayjs(FIRST_ARCHIVE_DATE).format('D MMMM, YYYY'),
              })}
            </p>
            <div
              onClick={playRandomGame}
              className="text-center bg-blue-600 hover:bg-blue-400 text-white p-2 rounded-md shadow-sm cursor-pointer"
            >
              {t('archive.playRandom')}
            </div>
            <Calendar
              initialDate={dayjs(FIRST_ARCHIVE_DATE)}
              onDateClick={(date) => goToArchiveGame(date.format('YYYY-MM-DD'))}
              getGameNumber={(date) => {
                const formattedDate = date.format('YYYY-MM-DD');
                return games.find((g) => g.date === formattedDate)?.number;
              }}
              lang={i18n.resolvedLanguage}
            />
          </>
        )}
      </div>
    </Container>
  );
};

export default ArchiveRoute;
